<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
export default {
  components: {
  },
  methods: {
   
  },
  created () {
    this.$store.dispatch('fetchAPIData')
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
}
</style>
